function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "primary-purple"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  colorInterpolationFilters: "sRGB",
  type: "matrix",
  values: "0.447     0     0     0     0                             0     0.141     0     0     0                             0     0     0.423     0     0                             0     0     0     1     0 "
})));
const SvgFilterDefs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    display: "none"
  },
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterDefs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-defs.4664c9bb.svg";
export { ForwardRef as ReactComponent };